export const PAGE_CSS_STYLES = {
  html: {
    position: "fixed",
    height: "100%",
    width: "100%",
    overflow: "hidden",
  },
  body: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0px",
    padding: "0px",
    overflow: "hidden",
    overscrollBehaviorY: "none",
    overscrollBehaviorX: "none",
    width: "100%",
    height: "100%",
    backgroundColor: "black",
  },
};

export const MAXIMUM_BUILD_SIZE = 25000000;
